//import http from "../http-common";
import api from "../http-common";

class FormacionInDataService {
  getAll(evento_id) {
    return api.get(`/formacionIn/?evento_id=${evento_id}`);
  }

  getRaw() {
    return api.get(`/formacionIn`);
  }

  getUserExist(evento_id, matricula) {
    return api.get(`/formacionIn/?evento_id=${evento_id}&matricula=${matricula}`);
  }
  
  getEventsAlumno(alumno_id){
    return api.get(`/formacionIn/listEventsData/?matricula=${alumno_id}`);
  }

  get(id) {
    return api.get(`/formacionIn/${id}`);
  }

  create(data) {
    return api.post("/formacionIn/create/", data);
  }

  update(id, data) {
    return api.put(`/formacionIn/update/${id}/`, data);
  }

  delete(id) {
    return api.delete(`/formacionIn/delete/${id}`);
  }

  getEgresados(ciclo) {
    return api.get(`/formacionIn/egresados/`, {
      params: {
        ciclo: ciclo
      }
    });
  }

  getCiclos() {
    return api.get(`/formacionIn/ciclos_lista/`);
  }

}

export default new FormacionInDataService();